import { useQuery } from "@tanstack/react-query";
import { fetchBlogFilters } from "../services/blogService";

function normalizeOptions(options = [], valueKey) {
  return (Array.isArray(options) ? options : []).map((option) => ({
    label: option?.name || "Option",
    value: option?.[valueKey],
  }));
}

export function useBlogFilters(params = {}, options = {}) {
  return useQuery({
    queryKey: ["dashboardBlogFilters", params],
    queryFn: async () => {
      const { payload } = await fetchBlogFilters(params);

      return [
        { id: "blog_category_id", title: "Category", icon: "bi bi-folder", options: normalizeOptions(payload?.blog_categories, "category_id") },
        { id: "tag_id", title: "Tags", icon: "bi bi-tags", options: normalizeOptions(payload?.tags, "tag_id") },
        { id: "read_unread_id", title: "Read Status", icon: "bi bi-book", options: normalizeOptions(payload?.read_unread, "read_unread_id") },
      ].filter((group) => group.options.length);
    },
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
  });
}
